import axios from "axios";
import { toInteger } from "lodash";
import { passengerCMSApi } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
export const fetchDataAndTransform = async (
  url: string,
  labelKey: string,
  valueKey?: string,
  filterFn?: (item: any) => boolean
): Promise<OptionType[]> => {
  try {
    const res = await axios.get(`${eramanHost}${url}`);
    if (res?.data) {
      const filteredData = filterFn ? res.data.filter(filterFn) : res.data;
      return filteredData.map((item: any) => ({
        label: decodeHTML(item[labelKey]),
        value: valueKey ? decodeHTML(item[valueKey]) : decodeHTML(item[labelKey]),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchSubCategoriesData = () => fetchDataAndTransform("/api/get-all-sub-categories", "name", "name");

export const fetchCategoriesData = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "field_category_name", (item) =>
    [73, 74, 75].includes(item.tid)
  );
export const fetchCategoriesDataById = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "tid", (item) => [73, 74, 75].includes(item.tid));

export const fetchCategoriesBannerData = () =>
  fetchDataAndTransform("/api/get-categories", "field_category_name", "field_category_name", (item) =>
    [73, 74, 75, 289].includes(item.tid)
  );

export const fetchBrandsData = () => fetchDataAndTransform("/api/get-brand-dropdown", "title", "title");

export const fetchAirportDropdownData = () => fetchDataAndTransform("/api/airport-dropdown", "name", "name");
export const fetchFoodBevarageDropdowData = () => fetchDataAndTransform("/api/food-beverage-dropdown", "name", "name");

export const fetchStoreDropdownData = async () => {
  try {
    const res = await axios.get(`${eramanHost}/api/store-location-dropdown`);
    console.log("loadOptionsdata", res.data);
    if (res?.data?.data) {
      return res.data.data.map((item: any) => ({
        label: decodeHTML(item.name),
        value: toInteger(item.id),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchChildHeaderDropdownDataByName = async () => {
  try {
    const res = await passengerCMSApi.get(`/api/get-child-menu/all-fields`);
    if (res?.data) {
      return res.data.map((item: any) => ({
        label: decodeHTML(item.name_en ?? item.name ?? ""),
        value: item.id,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchHeaderDropdownDataByStringId = async () => {
  try {
    const res = await passengerCMSApi.get(`/api/get-main-menu/all-fields`);
    if (res?.data) {
      const seen = new Set<string>();
      const unique: { label: string; value: any }[] = [];

      for (const item of res.data) {
        const key = String(item.id ?? item.name ?? "");
        if (seen.has(key)) continue;
        seen.add(key);
        unique.push({
          label: decodeHTML(item.name),
          value: String(item.id),
        });
      }

      return unique;
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};
